module.exports = __webpack_public_path__ + "img/report-4.876694de.jpg";